import Cookies from 'js-cookie'
import dayjs from 'dayjs'

export const TokenKey = 'chatglm_token'

const TokenExpiresKey = 'chatglm_token_expires'

export const RefreshTokenKey = 'chatglm_refresh_token'

const ConversationIdKey = 'conversation_id'

const SearchValueKey = 'chatglm_search_value'
const CaptchaRidKey = 'captcha_rid'
const NavigateRecordKey = 'model_navigate_record'
export const userId = 'chatglm_user_id'

/**
 * 清除带 . cookie
 */
export const removeOtherCookie = () => {
  try {
    Cookies.remove(TokenKey, { domain: '.' + location.hostname })
    Cookies.remove(RefreshTokenKey, { domain: '.' + location.hostname })
  } catch (error) {}
}

let cookieOpions = {
  expires: 30
}
let refreshCookieOpions = {
  expires: 180
}
if (process.env.NODE_ENV === 'production') {
  cookieOpions = {
    sameSite: 'None',
    secure: true,
    expires: 30
  }
  refreshCookieOpions = {
    sameSite: 'None',
    secure: true,
    expires: 180
  }
}
export function setToken(token) {
  console.log('--setToken--', token)
  return Cookies.set(TokenKey, token, cookieOpions)
}

export function getToken() {
  let token = Cookies.get(TokenKey)
  if (token) {
    token = 'Bearer ' + token
  }
  return token
}

export function setTokenExpires(expires) {
  console.log('--setTokenExpires--', expires)
  return Cookies.set(TokenExpiresKey, expires, cookieOpions)
}

export function getTokenExpires() {
  console.log('--getTokenExpires--')
  return Cookies.get(TokenExpiresKey)
}

export function setRefreshToken(token) {
  console.log('--setToken--', token)
  return Cookies.set(RefreshTokenKey, token, refreshCookieOpions)
}

export function getRefreshToken() {
  let token = Cookies.get(RefreshTokenKey)
  if (token) {
    token = 'Bearer ' + token
  }
  return token
}

export function removeToken() {
  console.log('--removeToken--', TokenKey)
  Cookies.remove(TokenKey)
  console.log('--removeRefreshToken--', RefreshTokenKey)
  Cookies.remove(RefreshTokenKey)
  Cookies.remove(userId)
  removeOtherCookie()
}

export function isTokensNotEmpty() {
  return !!getToken()
}
export function setUserId(id) {
  Cookies.set(userId, id, cookieOpions)
}
export function getUserId() {
  return Cookies.get(userId)
}

export function loginHandleToken(data) {
  const expiresH = dayjs().add(2, 'hour').format('YYYY-MM-DD HH:mm:ss')
  setToken(data.access_token)
  setTokenExpires(expiresH)
  setRefreshToken(data.refresh_token)
  setUserId(data.id || data.user_id || '')
}

const setLocalStorage = (key, val) => {
  let handleVal = val
  if (typeof val === 'object') {
    handleVal = JSON.stringify(val)
  }
  localStorage.setItem(key, handleVal)
}
const getLocalStorage = (key, type) => {
  const res = localStorage.getItem(key)
  if (!res || res === 'undefined') {
    return ''
  }
  if (type) {
    return JSON.parse(res)
  }
  return res
}

const getConversationId = () => {
  return getLocalStorage(ConversationIdKey)
}

const setConversationId = value => {
  return setLocalStorage(ConversationIdKey, value)
}
const getSearchKeyword = () => {
  return getLocalStorage(SearchValueKey)
}

const setSearchKeyword = (value = '') => {
  return setLocalStorage(SearchValueKey, value)
}
const getCaptchaRid = () => {
  return getLocalStorage(CaptchaRidKey)
}

const setCaptchaRid = (value = '') => {
  return setLocalStorage(CaptchaRidKey, value)
}
const getNavigateRecord = () => {
  return getLocalStorage(NavigateRecordKey)
}

const setNavigateRecord = value => {
  return setLocalStorage(NavigateRecordKey, value)
}

export {
  setConversationId,
  getConversationId,
  getCaptchaRid,
  setCaptchaRid,
  getSearchKeyword,
  setSearchKeyword,
  getNavigateRecord,
  setNavigateRecord
}
